import React, { Component } from 'react';
import './Dovesciare.css';
import "../../CommonStyles/CSS.css"
//import back from '../../images/public/registeration/back.png';
import help from '../../images/public/userarea/tab5u.png';
import noImage from '../../images/public/noImage.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
//import { ConsoleView, isBrowser } from 'react-device-detect';
import { isBrowser } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
// import Configminore from '../Configminore/Configminore';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
//import { addToCart } from '../../libs/fetch'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Cookies from 'universal-cookie';
//import { Button, Container, Row, Col } from 'react-bootstrap';
// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
// import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
import MPWorkFlow from "../../libs/workflow";
//import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
import { HtmlWrapper } from '../../Utils';
import InfoModal from "../../assets/components/Modal/Modal";
// const stageName = "Card";
//import itabar2 from '../../images/public/registeration/nav2i.png';
//import engbar2 from '../../images/public/registeration/nav2e.png';
//import simplebar2 from '../../images/public/registeration/mobilenav2.png';
import TopBar from '../../assets/components/topbar/TopBar';
import logo from '../../images/public/login/logo.png';
import CardSki1 from '../../images/public/registeration/CardSki1.svg';
import CardSki2 from '../../images/public/registeration/CardSki2.svg';
import miniArrow from '../../images/public/registeration/miniarrow.png';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
//import RoundCheckbox from '../../assets/components/checkbox/RoundCheckbox';

const cookies = new Cookies();
class Dovesciare extends Component {
  constructor(props) {
    super(props);

    let params = null;
    //console.log('[Resorts]', params);

    this.state = {
      // loadedData: false,
      // isLoading: false,
      step: '2',
      checked: "0",
      errmsg: null,
      errorFlg: false,
      purchaseCart: [],
      userOptions: [],
      canProceed: false,
      helpShow: false,
      helpMessage: "",
    };
  }

  componentDidMount() {
    // this.wf = new MPWorkFlow();
    // this.init();
    this.refresh();
  }

  alertResponse(info) {
    switch (info.type) {
      case "closeButton":
        this.setState({ errorFlg: false })
        break;
      case "actionButton":
        if (info.option1 === "attention")
          this.setState({ errorFlg: false })
        break;
      default:
        break;
    }
  }

  //new functions for new flow
  async init() {
    // update screenData for current states
    await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Card"));
    this.update();
  }

  async update() {
    // updating server state...
    let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: this.state.screenData });
    //console.log('[resorts] @update #resp', resp);
    if (!resp) return;
    if (resp.status === "success") {
      // updating localStorage
      MPWorkFlow.getInstance().updateWorkflow(this, resp.data);
      // updating current screen
      this.refresh();
    } /* else if (resp.status === "fail") {
			// call state and update the storage
			this.setState({ canProceed: false, errorFlg: true, errmsg: resp.message });
		} */
  }

  async refresh() {
    // update screenData for current states
    await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Card"));
    this.setState({ canProceed: this.state.screenData.link_next !== "" });
    // // sorting user's options
    this.orderUserOptions();
  }

  async transit(toWhere) {
    console.log('before workflowTransition 5');
    let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });
    //console.log('[resorts] @transit #resp', resp);
    if (resp.status === "success") {
      // updating localStorage and navigating to the new screen
      MPWorkFlow.getInstance().updateWorkflow(this, resp.data);
      let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
      // console.log("[resorts] @gotoResorts #getRouteName:", nextScreen);
      return this.props.history.push(nextScreen);
    } /*else if (resp.status === "fail") {
				this.setState({ errorFlg: true, errmsg: resp.message });
		}*/
  }

  // orders user's options by 'order' key inside 'options' object of screenData
  orderUserOptions() {
    // NOTE: each time an option changes, this function must be called after modifyWorkflow() call
    // order the options
    let options = Object.values(this.state.screenData.options).sort((x, y) => x.order - y.order);
    // console.log("[resorts] @orderUserOptions #options:", options);
    this.setState({ userOptions: options });
  }

  onUserOptionChanged = (id) => {
    let index = Number(id.split("-")[2]);
    //console.log("[resorts] @onUserOptionChanged #index:", index);
    // finding corresponding key in the object that matches the order index 
    let options = this.state.userOptions;
    //console.log("[resorts] @onUserOptionChanged #options:", options);
    let workflowOptions = this.state.screenData.options;
    //console.log("[resorts] @onUserOptionChanged #workflowOptions:", workflowOptions);
    const key = Object.keys(workflowOptions).find(key => workflowOptions[key].order === options[index].order);
    //console.log("[resorts] @onUserOptionChanged #key:", key);

    // blinking selected option
    let newOption = (workflowOptions[key].enabled === 1) ? 0 : 1;
    // setting the selected option
    options[index].enabled = newOption;
    workflowOptions[key].enabled = newOption;
    //console.log("[resorts] @onUserOptionChanged #workflowOptions:", workflowOptions);
    //console.log("[resorts] @onUserOptionChanged #options:", options);

    // update current screen
    this.setState({ userOptions: options });
    // updating wf
    let screenData = this.state.screenData;
    screenData.options = workflowOptions;

    //console.log("[resorts] @onUserOptionChanged #screenData:", screenData);
    this.update();
  }

  onClickMoreinfo = (e) => {
    e.preventDefault();
    let id = e.target.id;
    let index = Number(id.split("-")[2]);
    //console.log(index);
    this.showMoreModal(this.state.userOptions[index].desc_more);
  }

  showMoreModal = (msg) => {
    this.setState({
      helpShow: true,
      helpMessage: msg
    })
  }

  helpShowModal = (help_tag) => {
    MPWorkFlow.getInstance().workflowHelp(this, { tag: help_tag });
  }

  onBack = () => {
    //return this.props.history.push('/');
    this.transit(this.state.screenData.link_back);
  }

  gotoNextStage = (e) => {
    e.preventDefault();
    this.transit(this.state.screenData.link_next);
  }

  render() {
    return (
      <Router>
        <div>
          <div>
            <div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
              <div className="row flex-nowrap">
                <div className="col-2 d-flex align-items-center">
                  <button className="sn_btnbox" onClick={this.onBack}><img className="sn_mobile_top_row_arrow" src={miniArrow} /></button>
                </div>
                <div className="col-8 d-flex align-items-center justify-content-center">
                  <img className="sn_mobile_top_row_logo" src={logo} />
                </div>
                <div className="col-2 d-flex align-items-center justify-content-end">
                  <button className="sn_btnbox" onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img className="sn_mobile_top_row_quest" src={help} /></button>
                </div>
              </div>
            </div>
            <div className="sn_topbar"><TopBar step={this.state.step} /></div>
            <div className="sn_overlay d-lg-none"></div>
            <div className="sn_resorts">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-10 mx-auto">
                    <div className="sn_register__container p-3 p-lg-5">
                      <div className="row mb-4 mb-lg-0 mt-3 mt-lg-0">
                        <div className="col-12 d-none d-lg-flex justify-content-end">
                          {
                            this.state.screenData && this.state.screenData.help_tag &&
                            <div className="sn_quest">
                              <a onClick={() => this.helpShowModal(this.state.screenData.help_tag)}>
                                <img src={help} alt="" />
                              </a>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-12 text-center text-md-left">
                          <h2>{this.state.screenData && HtmlWrapper(this.state.screenData.title)}</h2>
                          <p>{this.state.screenData && HtmlWrapper(this.state.screenData.desc)}</p>
                        </div>
                      </div>
                      <div className="row mb-5">
                        {
                          this.state.userOptions.map((skicard, index) => {
                            return <SkiCard
                              key={`ski-card-key-${index}`}
                              id={`ski-card-${index}`}
                              skicard={skicard}
                              onChange={this.onUserOptionChanged}
                              onClickMoreinfo={this.onClickMoreinfo}
                            />
                          })
                        }
                      </div>
                      <div className="row mb-3">
                        <div className="col-12 text-center">
                          {
                            this.state.screenData && this.state.screenData.price_label &&
                            <h4><b>{HtmlWrapper(this.state.screenData.price_label + ": " + this.state.screenData.price_amount)}</b></h4>
                          }
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 d-flex flex-column flex-column-reverse align-items-center flex-sm-row justify-content-end">
                          <button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={this.onBack}>{tr.t('back')}</button>
                          <button disabled={!this.state.canProceed} className="sn_btn mb-3 mb-sm-0" onClick={this.gotoNextStage}>{this.state.screenData && this.state.screenData.next_button}</button>
                        </div>
                      </div>
                      <div className="row d-lg-none mt-5">
                        <div className="col-12">
                          <ProgressBullets step={this.state.step} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {
              this.state.errorFlg ?
                <div className="containerModal">
                  {
                    this.state.errorFlg ?
                      <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                  }
                </div> : null
            }
          </div>
          <WaitLoad enable={this.state.workFlowInProgress} />
          {this.state.helpShow && <InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })} />}
        </div>
      </Router>
    );
  }
}

export default Dovesciare;
class SkiCard extends React.Component {
  constructor(props) {
    //console.log('[Resorts] SkiCard checkIfImageIsValid props', props);
    super(props);

    this.state = {
      checked: props.skicard.enabled,
    }
    this.myRef = React.createRef();
    this.checkIfImageIsValid(this);
  }

  checkIfImageIsValid(that) {
    try {
      let img = this.props.skicard.icon;
      if (!img) {
        //console.warn("[Resorts] SkiCard checkIfImageIsValid no img!");
        //console.log("[Resorts] SkiCard checkIfImageIsValid Tag", document.getElementById('img-'+that.props.id));
      }
      var request = new XMLHttpRequest();
      request.open('GET', img, true);
      request.onreadystatechange = function () {
        //console.log('[Resorts] SkiCard checkIfImageIsValid #readyState', request.status);
        if (request.readyState === 4) {
          if (request.status === 404) {
            //console.warn('[Resorts] SkiCard checkIfImageIsValid #image', noImage);
            document.getElementById('img-' + that.props.id).src = noImage;
          }
          else
            switch (that.props.id.replace("ski-card-", "")) {
              case '0':
                document.getElementById('img-' + that.props.id).src = CardSki1;
                break;
              case '1':
                document.getElementById('img-' + that.props.id).src = CardSki2;
                break;
              default:
                break;
            }

          //console.log(this.props.skicard.icon);
        }
      };
      request.send();
    }
    catch (error) {
      document.getElementById('img-' + that.props.id).src = noImage;
      //console.warn("[Resorts] SkiCard checkIfImageIsValid", error);
    }
  }


  onChange = (e) => {
    this.props.onChange(this.props.id);
  }

  render() {
    if (isBrowser)
      return (
        <div className="col-12 col-lg-6 mb-3 mb-lg-0">
          <div className="row">
            <div className="col-2">
              <div className="sn_resorts__container__check p-3 p-md-0">
                <div className="sn_squareIn">
                  <input
                    id={this.props.id}
                    type="checkbox"
                    checked={this.props.skicard.enabled}
                    className="selected-checkbox"
                    onChange={this.onChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-10">
              <div className="sn_resorts__container__image mb-3">
                <img id={'img-' + this.props.id} className="skicard-image" alt="" />
              </div>
              <p className="mb-2 pr-lg-4">{HtmlWrapper(this.props.skicard.title)}</p>
              {
                this.props.skicard.desc ? <p className="mb-2 pr-lg-4" style={{ fontSize: 12 }}>{HtmlWrapper(this.props.skicard.desc)}</p> : null
              }
              {
                this.props.skicard.desc_more &&
                <h6 className="sn_more-info sn_underline" id={this.props.id} onClick={this.props.onClickMoreinfo}>
                  {tr.t("moreInfo")}
                </h6>
              }
              <h5>{HtmlWrapper(this.props.skicard.price_detail)}</h5>
            </div>
          </div>
        </div>
      )
    return (
      <div className="col-12 col-lg-6 mb-3 mb-lg-0">
        <div className="row">
          <div className="col-2">
            <div className="sn_resorts__container__check p-3 p-md-0">
              <div className="sn_squareIn">
                <input
                  id={this.props.id}
                  type="checkbox"
                  checked={this.props.skicard.enabled}
                  className="selected-checkbox"
                  onChange={this.onChange}
                />
              </div>
            </div>
          </div>
          <div className="col-10">
            <div className="sn_resorts__container__image mb-3">
              <img id={'img-' + this.props.id} className="skicard-image" alt="" />
            </div>
            <p className="mb-2 pr-lg-4">{HtmlWrapper(this.props.skicard.title)}</p>
            {
              this.props.skicard.desc_more &&
              <h5 className="sn_more-info sn_underline" id={this.props.id} onClick={this.props.onClickMoreinfo}>
                {tr.t("moreInfo")}
              </h5>
            }
            <h5>{HtmlWrapper(this.props.skicard.price_detail)}</h5>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/Dovesciare/Dovesciare.js